import React, { CSSProperties, ReactNode } from "react";

interface BadgeProps {
  children?: ReactNode;
  badgeComponent?: ReactNode;
  position?: "top-right" | "top-left" | "bottom-right" | "bottom-left";
  badgeStyle?: CSSProperties;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  badgeComponent,
  position = "top-right",
  badgeStyle,
}) => {
  return (
    <div className="badge-container" style={badgeStyle}>
      {children}
      {badgeComponent && (
        <div className={`badge-position${position ? ` ${position}` : ""}`}>
          {badgeComponent}
        </div>
      )}
    </div>
  );
};

export default Badge;
